[
  {
    "id": 0,
    "kana": "あ"
  },
  {
    "id": 1,
    "kana": "い"
  },
  {
    "id": 2,
    "kana": "う"
  },
  {
    "id": 3,
    "kana": "え"
  },
  {
    "id": 4,
    "kana": "お"
  },
  {
    "id": 5,
    "kana": "か"
  },
  {
    "id": 6,
    "kana": "き"
  },
  {
    "id": 7,
    "kana": "く"
  },
  {
    "id": 8,
    "kana": "け"
  },
  {
    "id": 9,
    "kana": "こ"
  },
  {
    "id": 10,
    "kana": "さ"
  },
  {
    "id": 11,
    "kana": "し"
  },
  {
    "id": 12,
    "kana": "す"
  },
  {
    "id": 13,
    "kana": "せ"
  },
  {
    "id": 14,
    "kana": "そ"
  },
  {
    "id": 15,
    "kana": "た"
  },
  {
    "id": 16,
    "kana": "ち"
  },
  {
    "id": 17,
    "kana": "つ"
  },
  {
    "id": 18,
    "kana": "て"
  },
  {
    "id": 19,
    "kana": "と"
  },
  {
    "id": 20,
    "kana": "な"
  },
  {
    "id": 21,
    "kana": "に"
  },
  {
    "id": 22,
    "kana": "ぬ"
  },
  {
    "id": 23,
    "kana": "ね"
  },
  {
    "id": 24,
    "kana": "の"
  },
  {
    "id": 25,
    "kana": "は"
  },
  {
    "id": 26,
    "kana": "ひ"
  },
  {
    "id": 27,
    "kana": "ふ"
  },
  {
    "id": 28,
    "kana": "へ"
  },
  {
    "id": 29,
    "kana": "ほ"
  },
  {
    "id": 30,
    "kana": "ま"
  },
  {
    "id": 31,
    "kana": "み"
  },
  {
    "id": 32,
    "kana": "む"
  },
  {
    "id": 33,
    "kana": "め"
  },
  {
    "id": 34,
    "kana": "も"
  },
  {
    "id": 35,
    "kana": "や"
  },
  {
    "id": 36,
    "kana": "ゆ"
  },
  {
    "id": 37,
    "kana": "よ"
  },
  {
    "id": 38,
    "kana": "ら"
  },
  {
    "id": 39,
    "kana": "り"
  },
  {
    "id": 40,
    "kana": "る"
  },
  {
    "id": 41,
    "kana": "れ"
  },
  {
    "id": 42,
    "kana": "ろ"
  },
  {
    "id": 43,
    "kana": "わ"
  }
]